import { handleHqOTracking, hqoMetadata, validateMetadata } from './utils';

interface initializeTrackingFunction {
  (
    authToken: string,
    currentBuildingUuid: string,
    appUuid: string,
    userAgent: string,
    clientApiUrl: string,
    bootstrappedMetadata?: Record<string, string | number | boolean | string[] | number[]>,
  ): void;
}
interface universalData {
  isInitialized: boolean;
  authToken: string;
  buildingUuid: string;
  appUuid: string;
  userAgent: string;
  clientApiUrl: string;
  bootstrappedMetadata?: Record<string, string | number | boolean | string[] | number[]>;
}

interface trackConfig {
  sendToHqoTracking?: boolean;
}

const webTrackingUniversalData: universalData = {
  isInitialized: false,
  authToken: '',
  buildingUuid: '',
  appUuid: '',
  userAgent: '',
  clientApiUrl: 'https://www.hqoapp.com',
};

export const track: (eventName: string, extraMetadata: hqoMetadata, config?: trackConfig) => Promise<void> = async (
  eventName: string,
  extraMetadata: hqoMetadata,
  config: trackConfig = {},
): Promise<void> => {
  if (!webTrackingUniversalData.isInitialized) {
    console.warn('Web tracking has not been initialized');
    return;
  }
  const metadata: hqoMetadata = {
    timestamp: Date.now(),
    ...extraMetadata,
    ...webTrackingUniversalData.bootstrappedMetadata,
    type: extraMetadata.type,
    building_uuid: webTrackingUniversalData.buildingUuid,
    app_uuid: webTrackingUniversalData.appUuid,
    user_agent: webTrackingUniversalData.userAgent,
  };

  const isMetadataValid = await validateMetadata(metadata);

  if (isMetadataValid) {
    if (config.sendToHqoTracking) {
      handleHqOTracking(webTrackingUniversalData.clientApiUrl, webTrackingUniversalData.authToken, eventName, metadata);
    }
  }
};

export const initializeWebTracking: initializeTrackingFunction = async (
  authToken,
  currentBuildingUuid,
  appUuid,
  userAgent,
  clientApiUrl,
  bootstrappedMetadata = {},
) => {
  if (authToken === '') {
    console.warn('User does not have an authToken: ', authToken);
    return;
  }
  webTrackingUniversalData.authToken = authToken;

  if (currentBuildingUuid === '') {
    console.warn('Current building uuid is invalid: ', currentBuildingUuid);
    return;
  }
  webTrackingUniversalData.buildingUuid = currentBuildingUuid;

  if (appUuid === '') {
    console.warn('Current app uuid is invalid: ', appUuid);
    return;
  }
  webTrackingUniversalData.appUuid = appUuid;

  if (userAgent === '') {
    console.warn('Current user agent is missing: ', userAgent);
    return;
  }
  webTrackingUniversalData.clientApiUrl = clientApiUrl;

  webTrackingUniversalData.userAgent = userAgent;
  webTrackingUniversalData.bootstrappedMetadata = bootstrappedMetadata;
  webTrackingUniversalData.isInitialized = true;
};
